import { Injectable } from '@angular/core';

/**
 * Shared utility service for Legislative Council components
 * Provides common helper methods to avoid code duplication
 */
@Injectable({
  providedIn: 'root'
})
export class LcUtilsService {

  /**
   * Normalize party name for matching
   * Removes letter codes (e.g., "K.", "E.", "I.") and converts to title case
   */
  public normalizePartyName(partyName: string): string {
    // Remove letter codes at the start
    let normalized = partyName.replace(/^[A-Z]\.\s+/, '');
    
    // Convert to title case
    normalized = normalized.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    
    return normalized;
  }

  /**
   * Get default color for a party based on common party colors
   */
  public getDefaultColorForParty(partyName: string): string {
    const lowerName = partyName.toLowerCase();
    
    if (lowerName.includes('labor') || lowerName.includes('labour')) {
      return '#E11B22'; // Red
    } else if (lowerName.includes('liberal')) {
      return '#0047AB'; // Blue
    } else if (lowerName.includes('green')) {
      return '#10C25B'; // Green
    } else if (lowerName.includes('one nation')) {
      return '#FF6300'; // Orange
    } else if (lowerName.includes('national')) {
      return '#006644'; // Dark Green
    } else {
      return '#808080'; // Gray for others
    }
  }

  /**
   * Parse a single CSV line handling potential commas within quoted fields
   */
  public parseCSVLine(line: string): string[] {
    const result: string[] = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    
    result.push(current.trim());
    return result;
  }

  /**
   * Format number with commas
   */
  public numberWithCommas(x: any): string {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
}
